import React, { FC } from 'react'
import { FooterNavPropsType, MenuType } from '../Footer.types'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../../common/utils/common-utils'
import { useFetch, usePrivacyOptOutCheck } from '../../../../common/utils/hooks'
import './footer-nav.scss'

export const FooterNav: FC<FooterNavPropsType> = props => {
  const { menuName, customerService, countryLink } = props
  const { description, heading, link } = customerService
  const showOptOut = usePrivacyOptOutCheck()
  const env = getCWPEnvironmentForURL(window.location.href)
  const footerMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
  const footerMenu = useFetch(footerMenuUrl)
  const { status: menuStatus, error: menuError, data } = footerMenu as unknown as MenuType
  const { menuItems } = data
  return (
    <div className='u-bgColorWhite u-paddingTop6gu u-paddingBottom12gu u-sm-paddingBottom6gu'>
      <div className='u-sizeConstrained'>
        <div className='Grid Grid--fill Grid--withGutter'>
          <div className='u-sizeFill u-lg-size2of3'>
            <nav role='navigation'>
              {menuStatus === 'fetching' && (
                <div className='Loading u-textColorBrandLight'>
                  <div className='Loading-indicator'></div>
                  <div className='Loading-indicator'></div>
                  <div className='Loading-indicator'></div>
                </div>
              )}
              {menuStatus === 'error' && <div>{menuError}</div>}
              <ul className='footer-nav u-decoUnbulleted u-flex u-flexCol u-flexWrap'>
                {menuItems?.map((menuItem, index) =>
                  menuItem.HstMenuItemRepresentation.name !==
                    'Do Not Sell or Share My Personal Data' || showOptOut ? (
                    <li
                      key={menuItem.HstMenuItemRepresentation.name}
                      className={
                        'u-marginBottom6gu' +
                        (menuItem.HstMenuItemRepresentation.name === 'Customer Service'
                          ? ' u-lg-hidden'
                          : '')
                      }>
                      <a
                        className='Link u-linkClean u-textBold u-textColorDefault'
                        href={menuItem.HstMenuItemRepresentation.url}>
                        {menuItem.HstMenuItemRepresentation.name}
                      </a>
                    </li>
                  ) : (
                    ''
                  )
                )}
              </ul>
            </nav>
          </div>
          <div className='u-sm-hidden u-md-hidden u-lg-size1of3'>
            <span>
              <span className='u-textPrimary u-textBold u-borderBottom u-borderColorNeutralLight u-paddingBottom2gu u-marginBottom2gu u-block'>
                {heading}
              </span>
              <p className='u-marginBottom8gu u-textColorLight'>{description}</p>
              <a className='Link' href={link}>
                Learn more
              </a>
              <a
                className='Link Link--external u-block u-marginTop15gu'
                href={countryLink.link}
                data-analytics={countryLink.label}>
                {countryLink.label}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
